import { useRecoilState } from "recoil";
import Table from "../reusable_components/Table";
import equipmentItems from "../atoms/equipmentItemsAtom";
import { useState } from "react";
import Modal from "../reusable_components/Modal";
import QRCode from "react-qr-code";
import { btnOne, btnSmall, btnSmallTwo, modalContainer, title } from "../utils/style";


function EquipmentItems() {
    const [ items ] = useRecoilState(equipmentItems);
    const [ qrItem, setQrItem ] = useState(false) 

    const options = [
        {
            header: 'Item Number',
            key: 'itemNumber'
        },
        {
            header: 'Serial Number',
            key: 'serialNumber'
        },
        {
            header: '',
            render: (data, ind) => { return <button className={btnSmallTwo} onClick={() => setQrItem(JSON.stringify(data))}>View QR</button> }
        }
    ]

    return(
        <div>
            {
                qrItem !== false && 
                <div className={modalContainer}>
                    <div className="flex flex-col gap-4 items-center justify-center">
                        <QRCode value={qrItem} />
                        <span>
                            <button onClick={() => setQrItem(false)} className={btnOne}>Close</button>
                        </span>
                    </div>
                </div>
            }
            <div className={title}>Special Equipment Items</div>
            <Table 
                options={ options } 
                tableData={items} 
                noFilter
                noButton
            />
        </div>
    )
}

export default EquipmentItems;